import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import WebAppsStore from 'sharedreact/stores/WebAppsStore';

import WebAppsLauncherPage from 'workspaces/launcher/components/webappslauncher/WebAppsLauncherPage';
import asFunctional from 'sharedreact/components/asFunctional';

type State = ConstructorParameters<typeof WebAppsLauncherPage>[0];

function getStores () {
  return [
    SettingsStore,
    WebAppsStore
  ];
}

function calculateState (prevState?: State): State {
  return {
    apps: WebAppsStore.getItems(),
    language: SettingsStore.getLanguage()
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(WebAppsLauncherPage),
  getStores,
  calculateState,
);
